import { createSlice } from '@reduxjs/toolkit';
import { ExportApi } from '../modules/export';

type TExport = {
  exportList: ExportApi.TExportList | null;
  exportSettings: ExportApi.TGetExportSettingsResponse | null;
};
const initialState: TExport = {
  exportList: null,
  exportSettings: null,
};

const exportSlice = createSlice({
  name: 'export',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(ExportApi.getExportList.fulfilled, (state, { payload }) => {
        state.exportList = payload;
      })
      .addCase(ExportApi.getExportSettings.fulfilled, (state, { payload }) => {
        state.exportSettings = payload;
      });
  },
});

export default exportSlice.reducer;
